"use strict"

import angular from "angular"
import uiRouter from "angular-ui-router"
import ngMaterial from "angular-material"
import ngCookies from "angular-cookies"
import ngResource from "angular-resource"
import ngSanitize from "angular-sanitize"
import "moment"
import "angular-spinkit"
import "angular-hammer"
import "ngclipboard"

import { routeConfig } from "./app.config"

import mainmap from "./mainmap/mainmap.component"
import markerdetail from "./markerdetail/markerdetail.component"
import dataService from "./dataService/dataService.service"
import anytimeService from "../app/services/anytime.service"
import windowresize from "./directives/windowresize"
import markerSelector from "./markerSelector/markerSelector"
import availabilitystatusreact from "./availabilitystatus/availabilityStatus/availabilityStatus"
import flexibilityChanger from "./flexibilityChanger/flexibilityChanger"
import fullScreenViewer from "./components/fullScreenViewer/fullScreenViewer"
import markersPanel from "./markerspanel/markerspanel.component"
import homePanel from "./homepanel/homepanel.component"
import homepanelmodal from "./homepanel/HomePanelModal/HomePanelModal"
import availabilityCheck from "./availabilitycheck/availabilitycheck.component"
import availabilityCheckModal from "./availabilitycheck/availabilityCheckModal/availabilityCheckModal"
import availabilityButton from "./availabilitybutton/availabilitybutton.component"
import availabilityStatus from "./availabilitystatus/availabilitystatus.component"
import pitchavailability from "./pitchavailability/pitchavailability.component"
import surroundings from "./surroundings/surroundings.component"
import rateLimitMessage from "./components/rateLimitMessage/rateLimitMessage.component"
import highlights from "./highlights/highlights.component"
import account from "./account/index"
import admin from "./admin/index"
import auth from "./components/auth/auth.module"
import ocLazyLoad from "oclazyload"

import "./app.scss"

angular
  .module("makeamapAngularApp", [
    anytimeService,
    ocLazyLoad,
    availabilityCheckModal,
    ngCookies,
    ngResource,
    ngSanitize,
    uiRouter,
    mainmap,
    markerdetail,
    dataService,
    windowresize,
    fullScreenViewer,
    "angular-spinkit",
    markersPanel,
    markerSelector,
    availabilitystatusreact,
    flexibilityChanger,
    homePanel,
    homepanelmodal,
    surroundings,
    ngMaterial,
    "hmTouchEvents",
    "ngclipboard",
    availabilityCheck,
    availabilityButton,
    highlights,
    availabilityStatus,
    pitchavailability,
    admin,
    auth,
    account,
    rateLimitMessage,
  ])
  .config(routeConfig)

angular.element(document).ready(() => {
  angular.bootstrap(document, ["makeamapAngularApp"], {
    strictDi: true,
  })
})
